// src/features/sales/api/emailApi.js
import api from "../../../shared/api/apiClient";

/**
 * Если у тебя бек реально слушает без /auth (т.е. /email/send),
 * просто замени AUTH_PREFIX на "".
 */

export const emailApi = {
  async sendSingle(payload) {
    // payload: { contact_id, to_email, subject, body, sender }
    const { data } = await api.post(`/email/send`, payload);
    return data;
  },

  async sendCorporate(payload) {
    // payload: { contact_ids, subject, body, template, tag, is_test, recipients, sender }
    const { data } = await api.post(`/email/corporate/send`, payload);
    return data;
  },

  async inbox(limit = 10) {
    const { data } = await api.get(`/email/inbox`, { params: { limit } });
    return data;
  },

  async getMode() {
    // returns: { mode, allow_sender_override, sender_options }
    const { data } = await api.get(`/email/mode`);
    return data;
  },
};
